import axios from 'axios'
// import router from '../../../router'

export const companiesRegistrationsBrand = {
  namespaced: true,
  state: {
    brand: {
      id: null,
      name: '',
      business_type_id: null
    },
    loading: false,
    loadError: false,
    errors: null,
  },
  mutations: {
    writeRegistrationsBrand(state) {
      state.loading = true
      state.loadError = false
      state.errors = null
    },
    readRegistrationsBrand(state) {
      state.loading = true
      state.loadError = false
      state.errors = null
    },
    readRegistrationsBrandSuccess(state, payload) {
      if (payload.data.length) {
        state.brand = {
          id: payload.data[0].id,
          name: payload.data[0].attributes.name,
          business_type_id: payload.data[0].attributes.business_type_id
        }
      }
      state.loading = false
    },
    writeRegistrationsBrandSuccess(state, payload) {
      state.brand = {
        id: payload.data.id,
        name: payload.data.attributes.name,
      }
      location.href = '/google_oauth/authorization/new?company_uuid=' + payload.companyUuid
      // GMB連携とフォーム入力選択可能になったらこちらへ
      // router.push('/s/companies/'+ payload.companyUuid +'/registrations/select')
      // state.loading = false
    },
    readRegistrationsBrandFailure(state, errors) {
      state.loading = false
      state.loadError = true
      state.errors = errors
    },
    writeRegistrationsBrandFailure(state, errors) {
      state.loading = false
      state.loadError = true
      state.errors = errors
    }
  },
  actions: {
    readRegistrationsBrand({ commit }, companyUuid) {
      commit('readRegistrationsBrand')
      return axios
        .get('/api/companies/'+ companyUuid +'/registrations/brands.json')
        .then(res => {
          commit('readRegistrationsBrandSuccess', res.data)
        })
        .catch(err => {
          commit('readRegistrationsBrandFailure', err)
          console.error(err)
        })
    },
    writeRegistrationsBrand({ commit, state }, companyUuid) {
      if (state.loading) return
      commit('writeRegistrationsBrand')
      const payload = {
        brand: state.brand,
      }
      if (state.brand.id) {
        axios
          .patch('/api/companies/'+ companyUuid +'/registrations/brands/' + state.brand.id, payload)
          .then(res => {
            const payload = res.data
            payload.companyUuid = companyUuid
            commit('writeRegistrationsBrandSuccess', payload)
          })
          .catch(err => {
            commit('writeRegistrationsBrandFailure', err)
            console.error(err)
          })
        return
      }
      axios
        .post('/api/companies/'+ companyUuid +'/registrations/brands', payload)
        .then(res => {
          const payload = res.data
          payload.companyUuid = companyUuid
          commit('writeRegistrationsBrandSuccess', payload)
        })
        .catch(err => {
          commit('writeRegistrationsBrandFailure', err)
          console.error(err)
        })
    }
  }
}
